import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { WebSocketProvider } from './utils/WebSocketManager'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <WebSocketProvider>
        <App />
      </WebSocketProvider> */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
